import { getService } from "../../reducers/service";
import { serviceNames } from "../../utils/constants";

export const getWorkOrderData = async (id) => {
	const service = await getService(serviceNames.perWorkOrders);
	return service.find({
		query: {
			id,
			isDeleted: false,
		},
	});
};

export const updateWorkOrderData = async (id, data) => {
	const service = await getService(serviceNames.perWorkOrders);
	const response = await service.patch(id, data);
	return response;
};

export const getVehicleOptions = async (userAgency) => {
	const service = await getService(serviceNames.perVehicles);
	const response = await service.find({
		query: {
			agencyId: userAgency,
			isDeleted: false,
			status: { $ne: "Retired" },
			$limit: -1,
		},
	});

	const vehicles = response?.data || response || [];

	return vehicles.map((vehicle) => ({
		label: `${vehicle.unitNumber || ""} — ${vehicle.year || ""} ${vehicle.make || ""} ${vehicle.model || ""}`.trim(),
		value: vehicle.id,
		id: vehicle.id,
		unitNumber: vehicle.unitNumber,
		year: vehicle.year,
		make: vehicle.make,
		model: vehicle.model,
		odometer: vehicle.odometer,
		status: vehicle.status,
		serviceRequirements: vehicle.serviceRequirements || [],
	}));
};

export const getVendorOptions = async (userAgency) => {
	const service = await getService(serviceNames.perWorkOrders);
	const response = await service.find({
		query: {
			agencyId: userAgency,
			isDeleted: false,
			$limit: -1,
		},
	});

	const workOrders = response?.data || response || [];

	const vendors = [
		...new Set(workOrders.map((wo) => wo.vendor).filter(Boolean)),
	];

	return vendors.map((vendor) => ({
		label: vendor,
		value: vendor,
	}));
};

export const getWorkOrderTypeOptions = async (dictionary) => {
	const codePerWorkOrderTypes = dictionary?.codePerWorkOrderTypes || [];

	return codePerWorkOrderTypes.map((type) => ({
		label: type?.Code || type?.code,
		value: type?.Code || type?.code,
		ptsCodeId: type?.ptsCodeId,
	}));
};

export const getWorkOrderStatusOptions = async (dictionary) => {
	const codePerWorkOrderStatus = dictionary?.codePerWorkOrderStatus || [];

	if (codePerWorkOrderStatus.length > 0) {
		return codePerWorkOrderStatus.map((status) => ({
			label: status?.Code || status?.code,
			value: status?.Code || status?.code,
			ptsCodeId: status?.ptsCodeId,
		}));
	}

	return [];
};
